import { useMemo } from "react";

import { Order, OrderDeliveryType } from "@web-app/types";

import { SortOptionType, sortOrders } from "../../utils";

const getLocationsForOrder = (order: Order) => {
  const locations =
    order.type === OrderDeliveryType.ROUTE_OPT_PICKUP
      ? [order.pickup.address]
      : order.type === OrderDeliveryType.ROUTE_OPT_DROPOFF
        ? [order.dropoff.address]
        : [order.pickup.address, order.dropoff.address];

  return [...new Set(locations.filter(Boolean))];
};

export default function useLocationsView({
  routedOrdersMap,
  unroutedOrders,
  searchTerm = "",
  sortParameter,
}: {
  routedOrdersMap: Map<string, Order>;
  searchTerm: string;
  sortParameter: SortOptionType;
  unroutedOrders: Order[];
}) {
  const groupedOrderLocations = useMemo(() => {
    const orderLocations = new Map<string, Order[]>();
    const orders = sortOrders(
      [...unroutedOrders, ...routedOrdersMap.values()],
      sortParameter,
    );

    for (const order of orders) {
      for (const locationName of getLocationsForOrder(order)) {
        const locationOrders = orderLocations.get(locationName) || [];
        locationOrders.push(order);
        orderLocations.set(locationName, locationOrders);
      }
    }

    return new Map(
      Array.from(orderLocations.entries()).filter(([, orders]) =>
        searchTerm ? true : orders.length > 1,
      ),
    );
  }, [routedOrdersMap, searchTerm, sortParameter, unroutedOrders]);

  return { groupedOrderLocations };
}
